import React from 'react';

import VerticalScrollableContainer from 'common/components/container/VerticalScrollableContainer';
import { Divider } from 'common/components/material';
import ExploreMenuItems from 'common/components/menu-items/explore-menu-items.component';
import QuickLinkMenuItems from 'common/components/menu-items/quick-link-menu-items.component';
import { useDrawer } from 'common/hooks';

import { FeatureGuard } from 'features/feature-access/components/feature-guard.component';
import { FeaturesEnum } from 'features/feature-access/features.enum';
import { DrawerIdEnum } from 'features/org-root/enums/drawer-id.enum';
import { MatchingEngineMenuItem } from '../menu-items/matching-engine-menu-item.component';
import MenuDrawerHeader from './menu-drawer-header.component';
import MenuItemsHeader from '../menu-items/menu-items-header.component';

const MenuDrawer: React.FC = () => {
  const { closeDrawer } = useDrawer();

  return (
    <>
      <MenuDrawerHeader label="Menu" onClick={() => closeDrawer(DrawerIdEnum.MENU)} />
      <VerticalScrollableContainer disableGutters>
        <div onClick={() => closeDrawer(DrawerIdEnum.MENU)}>
          <FeatureGuard features={[{ feature: FeaturesEnum.MATCHING_ENGINE }]}>
            <MenuItemsHeader label="Labs" dense>
              <MatchingEngineMenuItem />
            </MenuItemsHeader>
            <Divider />
          </FeatureGuard>
          <ExploreMenuItems />
          <FeatureGuard features={[{ feature: FeaturesEnum.ORGANIZATION_QUICK_LINKS }]}>
            <>
              <Divider />
              <QuickLinkMenuItems />
            </>
          </FeatureGuard>
        </div>
      </VerticalScrollableContainer>
    </>
  );
};

export default MenuDrawer;
